import { getAuthToken } from '@/constants/storageKeys'

interface AuthRequest {
	headers: Record<string, string>
}

const authPlugin = {
	request(req: AuthRequest, token: string): void {
		let t = getAuthToken() ?? token
		req.headers.Authorization = `Bearer ${t}`
	},
	response(): string | null {
		return getAuthToken()
	}
}

export default authPlugin
